module.exports = __webpack_public_path__ + "static/media/medical-consult-mission.ed2423b1.jpg";